<template>
  <card-item card="item_user_visits"  :tabs="tabs" :activeTab="activeTab" :id="id" :user="user" class="user-visits">
  </card-item>
</template>
<script>
import { cardContent } from "@/plugins/functions";
export default {
  methods: {
    cardContent
  },
  props: ["id"],
  async created(){
    this.user = await this.cardContent("/users", `${this.id}`);
  },
  data() {
    return {
      user: null,
      tabs: [
        {
          title: "Посещения",
          component: () => import("./Points"),
        },
          {
          title: "Маршрут",
          component: () => import("./Statuses"),          
        },

   
      ],
      activeTab: 0,
    };
  },
};
</script>
<style lang="scss">
  .user-visits{
    .tabs{
      margin-bottom: 10px;
    }
  }
</style>